$j(document).ready(function () {
  $j('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
    if (document.querySelector("body").hasAttribute('data-cart-check-agb') && document.querySelector("body").dataset.cartCheckAgb == 'false') {
      $j(this).submit();
      return true;
    }
    if ($j('#agree_agb').is(':checked') && $j('#agree_widerruf').is(':checked')) {
      $j(this).submit();
    }
    else {
      alert("Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.");
      return false;
    }
  });
  $j('body').on('click', '[name="contact-submit"]', function () {
    if ($j('#agree_contact').is(':checked')) {
      $j(this).submit();
    }
    else {
      alert("Bitte akzeptieren Sie unsere Datenschutzhinweise, bevor Sie Ihre Nachricht absenden.");
      return false;
    }
  });
  $j(function(){
    $j('.template-product .Product__Gallery .Product__SlideItem .AspectRatio').izoomify({
      magnify: 2.5,
      duration: 500
    });
  });
});
